module.exports = __webpack_public_path__ + "img/logo_tesfri_black.88c169d2.png";